import {Injectable} from '@angular/core';
import {SC_Input} from '../../common/input/SC_Input';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {RouterPathService} from '../../common/variables/router-path.service';
import {GlobalVariableService} from '../../common/variables/global-variable';
import {GlobalService} from '../../common/services/global.service';
import {GlobalFunctionService} from '../../common/services/global-function.service';
import {MountingType} from '../../common/mountsys/MountingType';
import {RoofType} from '../../common/roof/RoofType';
import {RoofPlanGetData} from '../../common/api/RoofPlanGet';
import {RoofPlanSaveInput} from '../../common/api/RoofPlanSave';
import {Global, setFence} from '../utilities/global';
import {getPanelCount} from '../panel/savePanelDetails';
import {ScaleAdjustmentValue} from '../getScaleFactor';
import {RoofHookInput} from '../stocklist/roofhook/RoofHookInput';
import {TrapezParameter} from '../input/TrapezParameter';

@Injectable({
  providedIn: 'root'
})
export class RoofParameterService {
  selectedProject$: Observable<any[]>;
  selectedProject: any;
  roofPlanPath: string;

  constructor(
    private routerPath: RouterPathService,
    private router: Router,
    public global: GlobalVariableService,
    public globalF: GlobalFunctionService,
    public globalService: GlobalService,
    private store: Store<any>) {

    this.roofPlanPath = this.routerPath.RPMountingPath;
    this.selectedProject$ = this.store.select(state => {
      return state.appData.selectedProject;
    });
    this.selectedProject$.subscribe((data: any) => {
      this.selectedProject = data;
    });
  }

  public setRoofParams() {
    let option: RoofPlanSaveInput = {
      id: SC_Input.sPlan ? parseInt(SC_Input.sPlan.id) : 0,
      projectID: SC_Input.sProject.selectedProject.id,
      name: SC_Input.sName,
      windZone: this.selectedProject.windZone,
      snowZone: this.selectedProject.snowZone,
      terrainCategory: this.selectedProject.terrainCategory,
      terrainHeight: this.selectedProject.terrainHeight,
      roofType: SC_Input.iRoofType,
      roofShape: SC_Input.iRoofShape,
      roofPitch: SC_Input.iRoofAngle,
      roofA: SC_Input.a,
      roofB: SC_Input.b,
      roofC: SC_Input.c,
      roofD: SC_Input.d,
      buildingHeight: SC_Input.iBuilding,
      roofOrientation: SC_Input.sRoofOrientationDeg,
      roofObstructions: Global.roofObstructions ? Global.roofObstructions : [],
      panelCount: SC_Input.iModulCount,
      totalCapacity: 0,
      projectPanel: SC_Input.sPlanDetails.projectPanel ? SC_Input.sPlanDetails.projectPanel : this.selectedProject.panelID == SC_Input.sPanel.id,
      panelID: parseInt(SC_Input.sModulID),
      panelRows: ScaleAdjustmentValue.getPanelRows(Global.panelRows),
      items: SC_Input.roofPlanItems,
      noEdges: Global.toggleBoundaryArea,
      cantileverValid: Global.cantileverValid,
      mountSystem: SC_Input.iMountSys,
      mountType: SC_Input.iMountingType,
      mountColor: SC_Input.iFrameColor,
      battenDivision: SC_Input.iBattenDivision,
      purlinMaterial: SC_Input.iBeamMat,
      roofHookBasePlate: SC_Input.roofhookinputCurrent.iBasePlate,
      roofHookType: SC_Input.roofhookinputCurrent.iType,
      hProfile: SC_Input.sHProfile,
      profileLength: SC_Input.iProfileLen, //?
      hangerBolt: SC_Input.sStosch.toString(),
      beamType: SC_Input.iBeamType,
      beamSpace: SC_Input.nBeamDist,
      beamFirst: SC_Input.nBeamDist1,
      trapezMaterial: SC_Input.trapezPara.iMaterial ? SC_Input.trapezPara.iMaterial : SC_Input.iTrapezMaterial,
      trapezTopChord: SC_Input.trapezPara.iTopChord,
      trapezBottomChord: SC_Input.trapezPara.iBottomChord,
      trapezCalotteSize: SC_Input.trapezPara.iCalotteSize,
      trapezProfileHeight: SC_Input.trapezPara.iProfileHeight,
      trapezHighBeadingSpace: SC_Input.nHighBeadingDistance,
      trapezThickness: SC_Input.nTrapezSheetThickness,
      adhesiveTapeColor: SC_Input.sIDAnsKleBanCol,
      calculatedStatics: SC_Input.planStatics,
      invalid: false,
      version: 0,
      overviewPanelImg: Global.panelOverviewImage,
      overviewSubframeImg: Global.panelSubframeImage,
      overviewSubframeProfileCutImg: Global.panelSubframeProfileCutImage,
      googleMapImage: Global.googleMapImage,
    };
    return option;
  }

  public getRoofParams() {
    const qParam = {
      cmd: this.global.RoofPlanGet,
      id: SC_Input.sPlan.id
    };
    this.globalService.getData(qParam).subscribe((data: any) => {
      if (data && data.ok) {
        localStorage.setItem("sen_nBeamDist_rafter", "");
        localStorage.setItem("sen_nBeamDist_purlin", "");
        let roofParams: RoofPlanGetData = data.ok.data;
        SC_Input.sPlanDetails = roofParams;
        setFence(roofParams.roofObstructions);
        SC_Input.sPlanDetails.panelRows = ScaleAdjustmentValue.getPanelRows(SC_Input.sPlanDetails.panelRows, true);
        SC_Input.sName = roofParams.name;
        SC_Input.iRoofType = roofParams.roofType;
        SC_Input.iRoofShape = roofParams.roofShape;
        SC_Input.iRoofAngle = roofParams.roofPitch;
        SC_Input.a = roofParams.roofA;
        SC_Input.b = roofParams.roofB;
        SC_Input.c = roofParams.roofC;
        SC_Input.d = roofParams.roofD;
        SC_Input.sRoofOrientationDeg = roofParams.roofOrientation;
        SC_Input.iBuilding = roofParams.buildingHeight;
        // roofObstructions: [],
        SC_Input.iModulCount = roofParams.panelCount;
        // totalCapacity: 0,
        // panelID: 0,
        // panelRows: [],

        // noEdges: false;
        // cantileverValid:  Global.cantileverValid;
        SC_Input.iMountSys = roofParams.mountSystem;
        SC_Input.iMountingType = roofParams.mountType;
        SC_Input.iFrameColor = roofParams.mountColor;
        SC_Input.iBattenDivision = roofParams.battenDivision;
        SC_Input.iBeamMat = roofParams.purlinMaterial;
        SC_Input.roofhookinputCurrent = new RoofHookInput();
        SC_Input.roofhookinputCurrent.iBasePlate = roofParams.roofHookBasePlate;
        SC_Input.roofhookinputCurrent.iType = roofParams.roofHookType;
        SC_Input.sHProfile = roofParams.hProfile;
        // profileLength: SC_Input.iProfileLen, //?
        SC_Input.sStosch = parseInt(roofParams.hangerBolt);
        SC_Input.iBeamType = roofParams.beamType;
        SC_Input.nBeamDist = roofParams.beamSpace;
        SC_Input.nBeamDist1 = roofParams.beamFirst;

        if (roofParams.panelRows) {
          getPanelCount(true);
        }
        SC_Input.trapezPara = new TrapezParameter();
        if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
          SC_Input.trapezPara.iMaterial = roofParams.trapezMaterial;
        } else {
          SC_Input.iTrapezMaterial = roofParams.trapezMaterial;
        }
        SC_Input.trapezPara.iTopChord = roofParams.trapezTopChord;
        SC_Input.trapezPara.iBottomChord = roofParams.trapezBottomChord;
        SC_Input.trapezPara.iCalotteSize = roofParams.trapezCalotteSize;
        SC_Input.trapezPara.iProfileHeight = roofParams.trapezProfileHeight;
        SC_Input.nHighBeadingDistance = roofParams.trapezHighBeadingSpace;
        SC_Input.nTrapezSheetThickness = roofParams.trapezThickness;
        SC_Input.sIDAnsKleBanCol = roofParams.adhesiveTapeColor;
        //following assigned in project level
        // SC_Input.sWindzone = roofParams.windZone;
        // SC_Input.sSchneezone = roofParams.snowZone;
        // SC_Input.sTerrainCat = roofParams.terrainCategory;
        // SC_Input.iTerrain = roofParams.terrainHeight;

        // invalid: false,
        // version: 0
        this.router.navigate([this.roofPlanPath]);
      }
    });
  }
}
